export default __webpack_public_path__ + "static/media/LoadingSwoosh.2bfad144.svg";